import { some, find } from 'lodash';
import { matchPath } from 'react-router-dom';
import React from 'react';
import MenuIcon from './MenuIcon';
import TabConfig from './TabConfig.js';
import { MAP_PATH } from '../../../utils/globals';

const ubersichtName = 'Lage-Übersicht';
const ubersichtNameNew = 'Preis-Übersicht';

export const TAB = {
  home: new TabConfig({
    id: 'home',
    name: ubersichtName,
    nameNew: ubersichtNameNew,
    icon: () => <MenuIcon className="is24-icon-price-map" />,
    trackingLabel: 'navigation_dashboard_overview',
    isActive: (pathname) =>
      pathname === `/${ubersichtName}`.toLowerCase() ||
      pathname === `/${ubersichtNameNew}`.toLowerCase() ||
      pathname === '/',
  }),
  listings: new TabConfig({
    id: 'listings',
    name: 'Immobilienangebote',
    icon: () => <MenuIcon className="is24-icon-new-apartment-building" />,
    trackingLabel: 'navigation_listings_view',
    isActive: (pathname) => pathname.includes('/immobilienangebote'),
  }),
  priceHistory: new TabConfig({
    id: 'priceHistory',
    name: 'Preisentwicklung',
    icon: () => <MenuIcon className="is24-icon-statistic-with-arrow-up" />,
    trackingLabel: 'navigation_price_dev_view',
  }),
  priceCheck: new TabConfig({
    id: 'priceCheck',
    name: 'Preis-Check',
    icon: () => <MenuIcon className="is24-icon-price-check" />,
    trackingLabel: 'navigation_price_check_view',
  }),
  selling: new TabConfig({
    id: 'selling',
    name: 'Nachfrage-Check',
    icon: () => <MenuIcon className="is24-icon-house-with-loupe" />,
    trackingLabel: 'navigation_selling_view',
  }),
  myProperty: new TabConfig({
    id: 'myProperty',
    name: 'Meine Immobilie',
    icon: () => <MenuIcon className="is24-icon-building-single-family-house" />,
    trackingLabel: 'navigation_myproperty',
    displayName: 'Eigentümerbereich',
    dataIdentifier: 'my-property-tab',
  }),
};

export const getActiveTab = (path) => tabIdByRoute(path);

function tabIdByRoute(route) {
  switch (route) {
    case `/${TAB.listings.name}`:
      return TAB.listings.id;
    case `/${TAB.listings.name}/${MAP_PATH}`:
      return TAB.listings.id;
    case `/${TAB.priceHistory.name}`:
      return TAB.priceHistory.id;
    case `/${TAB.priceCheck.name}`:
      return TAB.priceCheck.id;
    case `/${TAB.selling.name}`:
      return TAB.selling.id;
    case `/${TAB.myProperty.name}`:
      return TAB.myProperty.id;
    case `/${TAB.myProperty.name}/edit`:
      return TAB.myProperty.id;
    default:
      return TAB.home.id;
  }
}

const findPageId = (route) => {
  const pageViewIdByPath = [
    { path: `/${TAB.listings.name}`, pageViewId: `${TAB.listings.id}_list` },
    { path: `/${TAB.listings.name}/${MAP_PATH}`, pageViewId: `${TAB.listings.id}_map` },
    { path: `/${TAB.listings.name}/${MAP_PATH}/:detailedListingId`, pageViewId: `${TAB.listings.id}_map` },
    {
      path: `/${TAB.listings.name}/${MAP_PATH}/:detailedListingId/contact`,
      pageViewId: `${TAB.listings.id}_map/CSL_contact_form`,
    },
    { path: `/${TAB.priceHistory.name}`, pageViewId: `${TAB.priceHistory.id}` },
    { path: `/${TAB.priceCheck.name}`, pageViewId: `${TAB.priceCheck.id}` },
    { path: `/${TAB.selling.name}`, pageViewId: `${TAB.selling.id}` },
    { path: `/${TAB.myProperty.name}`, pageViewId: `${TAB.myProperty.id}` },
    { path: `/${TAB.myProperty.name}/edit`, pageViewId: `${TAB.myProperty.id}` },
    { path: `/${TAB.home.getName()}`, pageViewId: `${TAB.home.id}` },
  ];

  const found = find(pageViewIdByPath, (pageView) =>
    Boolean(matchPath(unescape(route), { path: pageView.path, exact: true })),
  );
  return found ? found.pageViewId : `${TAB.home.id}`;
};

export const getActiveView = (path) => findPageId(path);

export const isKnownTab = (route) => {
  const knownTabPaths = [
    `/${TAB.listings.name}`,
    `/${TAB.listings.name}/${MAP_PATH}`,
    `/${TAB.listings.name}/${MAP_PATH}/:detailedListingId`,
    `/${TAB.listings.name}/${MAP_PATH}/:detailedListingId/contact`,
    `/${TAB.listings.name}/${MAP_PATH}/:detailedListingId/paywall`,
    `/${TAB.priceHistory.name}`,
    `/${TAB.priceCheck.name}`,
    `/${TAB.selling.name}`,
    `/${TAB.myProperty.name}`,
    `/${TAB.myProperty.name}/edit`,
    '/',
    `/${TAB.home.getName()}`,
  ];
  return some(knownTabPaths, (path) => Boolean(matchPath(route, { path, exact: true })));
};

export const TAB_CONFIG = [TAB.myProperty, TAB.home, TAB.listings, TAB.priceHistory, TAB.priceCheck, TAB.selling];

export const navigateToUrl = (history, url) => history.push(url);

export const navigateTo = (history, tab) => {
  if (tab.id === 'listings') {
    navigateToUrl(history, `/${tab.name}/${MAP_PATH}`);
  } else {
    navigateToUrl(history, `/${tab.getName()}`);
  }
};

export const fullMapRoute = `/${TAB.listings.name}/${MAP_PATH}`;
